module.exports = __webpack_public_path__ + "img/school.46f2ae92.svg";